import * as focusTrap from 'focus-trap';

export const closeModal = (modal) => {
  modal.querySelectorAll('[aria-hidden="false"]').forEach((el) => {
    el.setAttribute('aria-hidden', true);
  });
  modal.classList.add('hidden');
}

const getFocusTrap = (modal) => {
  const modalOverlay = modal.querySelector('.modal-overlay');
  return focusTrap.createFocusTrap(modal, {
    allowOutsideClick: true,
    onActivate: () => {
      modal.classList.remove('hidden');
      modal.querySelectorAll('[aria-hidden="true"]').forEach((el) => {
        el.setAttribute('aria-hidden', false);
      });
      modalOverlay.classList.remove('opacity-0');
      modalOverlay.classList.add('opacity-75');
    },
    checkCanFocusTrap: (trapContainers) => {
      const results = trapContainers.map((trapContainer) => {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            if (getComputedStyle(trapContainer).visibility !== 'hidden') {
              resolve();
              clearInterval(interval);
            }
            // increase this if focusTrap says it does find focusable divs
          }, 1000);
        });
      });
      // Return a promise that resolves when all the trap containers are able to receive focus
      return Promise.all(results);
    },
    onDeactivate: () => {
      closeModal(modal);
    },
  });
};

export const trapFocusOnModal = ({ modal, trigger }) => {
  const modalCloseBtn = modal.querySelector('.close-button');
  const trap = getFocusTrap(modal);
  modalCloseBtn.addEventListener('click', trap.deactivate);
  // if we pass a trigger, modal is displayed on click on it. Otherwise, when this function is called.
  if (trigger) {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      trap.activate();
    });
  } else {
    trap.activate();
  }
};
